module.exports = __webpack_public_path__ + "static/media/EUR.a02bc0c3.jpg";